const listOfQA = [
  {
    id: 1,
    eng: {
      title: "How do I add a milonga / práctica / class?",
      text: "You should log in and go to Menu >> Create, and choose in the category field whether it is a milonga, práctica, a class, etc. Then fill in all the fields including the address so users can find you.",
    },
    spa: {
      title: "¿Cómo puedo añadir una milonga / práctica / clase?",
      text: "Deberías iniciar tu sesión e ir a Menu >> Crear, y elegir en la parte de la categoría si se trata de una milonga, práctica, una clase, etc. Luego, rellena todos los campos incluído el de la dirección para que los usuarios puedan encontrarte.",
    },
  },
  {
    id: 3,
    eng: {
      title:
        "I have found my milonga / práctica / class on the map. How can I access and update it?",
      text: "Open the details of the venue on the map, scroll down to find the <strong>Edit</strong> button and click it. The edit page will open where you can modify or add all the event data. Finally, save the changes by clicking <strong>Save</strong>. In Menu >> <strong>Lead Venues</strong> you will see your event status as <strong>Pending</strong>. We will review the data and once <strong>Approved</strong>, it will be available on the map for other users.",
      textGuest: "To access and update your space, request an access link. Once approved, you'll receive it by email — just click it to enter your account. No password needed.",
      stepsGuest: [
        { icon: "icon-send", eng: "Request access", spa: "Solicitá acceso" },
        { icon: "icon-mail", eng: "Receive the link by email", spa: "Recibí el enlace por email" },
        { icon: "icon-link", eng: "Click the access link", spa: "Hacé clic en el enlace" },
        { icon: "icon-check-circle", eng: "Manage your space!", spa: "¡Gestioná tu espacio!" },
      ],
      steps: [
        {
          icon: "icon-map-pin",
          eng: "Open the venue details on the map",
          spa: "Abre los detalles del evento en el mapa",
        },
        {
          icon: "icon-chevrons-down",
          eng: 'Scroll down to the "Edit" button',
          spa: 'Desliza hasta el botón "Editar"',
        },
        { icon: "icon-edit", eng: 'Click "Edit"', spa: 'Haz clic en "Editar"' },
        {
          icon: "icon-save",
          eng: 'Modify and click "Save"',
          spa: 'Modifica y haz clic en "Guardar"',
        },
        {
          icon: "icon-box",
          eng: 'Lead Venues → "Pending"',
          spa: 'Gestión de eventos → "Pendiente"',
        },
        {
          icon: "icon-check-circle",
          eng: "Approved → live on the map!",
          spa: "¡Aprobado → en el mapa!",
        },
      ],
    },
    spa: {
      title:
        "Encontré mi milonga / práctica / clase en el mapa. ¿Cómo puedo accederla y actualizarla?",
      text: "Accede a los detalles donde encontrarás toda la información del evento. Desliza hacia abajo hasta encontrar el botón <strong>Editar</strong> y haz clic en él. Se abrirá la página de edición donde podrás modificar o agregar todos los datos. Por último, guarda los cambios haciendo clic en <strong>Guardar</strong>. En Menu >> <strong>Gestión de eventos</strong> podrás ver el estado de tu evento como <strong>Pendiente</strong>. Nosotros revisaremos los datos y una vez <strong>Aprobado</strong>, estará disponible en el mapa para los demás usuarios.",
      textGuest: "Para acceder y actualizar tu espacio, solicitá un enlace de acceso. Una vez aprobado, lo recibirás por email. Solo hacé clic en el enlace para entrar a tu cuenta, sin necesidad de contraseña.",
      stepsGuest: [
        { icon: "icon-send", eng: "Request access", spa: "Solicitá acceso" },
        { icon: "icon-mail", eng: "Receive the link by email", spa: "Recibí el enlace por email" },
        { icon: "icon-link", eng: "Click the access link", spa: "Hacé clic en el enlace" },
        { icon: "icon-check-circle", eng: "Manage your space!", spa: "¡Gestioná tu espacio!" },
      ],
      steps: [
        {
          icon: "icon-map-pin",
          eng: "Open the venue details on the map",
          spa: "Abre los detalles del evento en el mapa",
        },
        {
          icon: "icon-chevrons-down",
          eng: 'Scroll down to the "Edit" button',
          spa: 'Desliza hasta el botón "Editar"',
        },
        { icon: "icon-edit", eng: 'Click "Edit"', spa: 'Haz clic en "Editar"' },
        {
          icon: "icon-save",
          eng: 'Modify and click "Save"',
          spa: 'Modifica y haz clic en "Guardar"',
        },
        {
          icon: "icon-box",
          eng: 'Lead Venues → "Pending"',
          spa: 'Gestión de eventos → "Pendiente"',
        },
        {
          icon: "icon-check-circle",
          eng: "Approved → live on the map!",
          spa: "¡Aprobado → en el mapa!",
        },
      ],
    },
  },
  {
    id: 2,
    eng: {
      title:
        "My milonga / práctica / event is on the map but I can't manage it yet.",
      text: 'If you are the owner of a milonga, práctica, or any other event listed on the map but don\'t have access to manage it, please reach out to us via <i class="feather icon-mail" style="color:#4e6ac5"></i> <strong>Contact us</strong> in the left menu. Explain your situation and we will grant you the necessary permissions so you can manage your event.',
    },
    spa: {
      title:
        "Mi milonga / práctica / evento está en el mapa pero aún no puedo gestionarlo.",
      text: 'Si sos el/la dueño/a de una milonga, práctica u otro evento que ya está en el mapa pero no tenés acceso para gestionarlo, contáctanos desde el menú de la izquierda en <i class="feather icon-mail" style="color:#4e6ac5"></i> <strong>Contáctanos</strong>. Explicanos la situación y te daremos los permisos necesarios para que puedas gestionarlo.',
    },
  },
  {
    id: 4,
    eng: {
      title: "How do I contact you if I have any further questions?",
      text: 'In the left menu select <i class="feather icon-mail" style="color:#4e6ac5"></i> <strong>Contact us</strong>. There you can write to us and we will reply shortly. You will receive a notification which you can see at the top via the <i class="feather icon-bell" style="color:#4e6ac5"></i> bell icon.',
    },
    spa: {
      title: "¿Cómo puedo ponerme en contacto con ustedes si tengo preguntas?",
      text: 'En el menú de la izquierda selecciona <i class="feather icon-mail" style="color:#4e6ac5"></i> <strong>Contáctanos</strong>. Allí podrás escribirnos y te responderemos a la brevedad, recibiendo una notificación, la cual podrás ver en la parte superior en el icono de la <i class="feather icon-bell" style="color:#4e6ac5"></i> campanilla.',
    },
  },
  {
    id: 9,
    eng: {
      title:
        "How can I add an event type that is not yet supported in Create >> Category?",
      text: 'If the category you need is not available yet, feel free to reach out via <i class="feather icon-mail" style="color:#4e6ac5"></i> <strong>Contact us</strong> and let us know which category you\'d like us to add. We\'re always looking to expand what Bailo.app supports!',
    },
    spa: {
      title:
        "¿Cómo puedo agregar un evento cuya categoría no está disponible aún en Crear >> Categoría?",
      text: 'Si la categoría que necesitas no está disponible todavía, contáctanos haciendo clic en <i class="feather icon-mail" style="color:#4e6ac5"></i> <strong>Contáctanos</strong> e indícanos qué categoría te gustaría que agreguemos. ¡Siempre estamos buscando ampliar lo que Bailo.app ofrece!',
    },
  },
  {
    id: 10,
    eng: {
      title: "I have found a bug / coding error.",
      text: 'Great! Please contact us by clicking on <i class="feather icon-mail" style="color:#4e6ac5"></i> <strong>Contact us</strong> in the left menu. We love solving bugs! 😃',
    },
    spa: {
      title: "Encontré un fallo en la página web.",
      text: '¡Buenísimo! Por favor, contáctanos haciendo clic en <i class="feather icon-mail" style="color:#4e6ac5"></i> <strong>Contáctanos</strong> en el menú de la izquierda. ¡Nos encanta resolver los fallos en nuestro código! 😃',
    },
  },
  {
    id: 12,
    eng: {
      title: "What is an access link?",
      text: "It is a secure link you receive by email to enter your account without a password. Just click the link and you'll be able to manage your space on Bailo.app.",
    },
    spa: {
      title: "¿Qué es un enlace de acceso?",
      text: "Es un enlace seguro que recibes por email para entrar a tu cuenta sin contraseña. Solo tienes que hacer clic en el enlace y podrás gestionar tu espacio en Bailo.app.",
    },
  },
  {
    id: 11,
    eng: { title: "Bailo.app is for free, right?", text: "Yes, it is 😃 ." },
    spa: { title: "Bailo.app es gratis, ¿verdad?", text: "Sí, es gratis 😃 ." },
  },
];

module.exports = {
  listOfQA,
};
